(function () {
  function initComparison(root) {
    if (!root || root.dataset.beforeAfterInit === 'true') return;

    const input = root.querySelector('[data-before-after-input]');
    if (!input) return;

    root.dataset.beforeAfterInit = 'true';

    const setPosition = (value) => {
      const pos = Math.min(100, Math.max(0, Number(value)));
      root.style.setProperty('--bd-before-after-pos', `${pos}%`);
      input.value = pos;
      input.setAttribute('aria-valuenow', String(pos));
    };

    setPosition(input.value || root.dataset.initialPosition || 50);

    input.addEventListener('input', function () {
      setPosition(this.value);
    });
  }

  function initAll(scope) {
    const container = scope || document;
    container.querySelectorAll('[data-before-after]').forEach(initComparison);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
